import { SortingDirection } from 'src/shared/components/data-table/dataTableTypes';
import type { TableRowsSortingFunction } from 'src/shared/components/data-table/dataTableTypes';
import { formatStandardDate } from 'src/shared/utils/dateHelpers';

export const dateSortFn: TableRowsSortingFunction = (tableRows, columnIndex, direction) => {
    const toTs = (d?: string) => (d ? new Date(d).getTime() : 0);
    const sortedRows = [...tableRows].sort((a, b) => {
        const aVal = String(a.cells[columnIndex] || '');
        const bVal = String(b.cells[columnIndex] || '');
        return toTs(aVal) - toTs(bVal);
    });
    if (direction === SortingDirection.DESC) {
        return sortedRows.reverse();
    }
    return sortedRows;
};

export const sizeSortFn: TableRowsSortingFunction = (tableRows, columnIndex, direction) => {
    const parseKb = (value: unknown) => {
        const text = String(value || '').trim();
        const match = text.match(/^(\d+)/);
        if (!match) {
            return 0;
        }
        const kb = Number(match[1]);
        if (Number.isNaN(kb)) {
            return 0;
        }
        return kb;
    };

    const sortedRows = [...tableRows].sort((a, b) => {
        const aKb = parseKb(a.cells[columnIndex]);
        const bKb = parseKb(b.cells[columnIndex]);
        return aKb - bKb;
    });

    if (direction === SortingDirection.DESC) {
        return sortedRows.reverse();
    }
    return sortedRows;
};

export const formatUploadDate = (dateString: string | undefined) => {
    if (!dateString) {
        return '';
    }
    try {
        return formatStandardDate(dateString);
    } catch (_error) {
        // Fall back to raw string if date is invalid
        return dateString;
    }
};
